import { render, staticRenderFns } from "./AddSenderProductModal.vue?vue&type=template&id=129eef9f&scoped=true"
import script from "./AddSenderProductModal.vue?vue&type=script&lang=js"
export * from "./AddSenderProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129eef9f",
  null
  
)

export default component.exports